<template>
  <v-overlay :opacity="0.5">
    <span>
      {{
      $tc("dashboard.loading")
      }}
    </span>
    <v-progress-linear buffer-value="0" stream color="#45D6E5"></v-progress-linear>
  </v-overlay>

</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
 
<style scoped>
.col-loader {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (min-width: 1024px) and (max-width: 1370px) {

  .container_loading {
    height: 550px !important;
  }
}

@media (min-width: 1370px) and (max-width: 1900px) {

  .container_loading {
    height: 800px !important;
  }
}

/*
@media (min-width: 400px) and (max-width: 596px) {
  .col-loader {
    display: flex;
    justify-content: center;
  }
  .loading {
    min-height: 100px;
    height: 500px !important;
  }
}
@media (min-width: 596px) and (max-width: 1024px) {
  .loading {
    min-height: 500px;
    height: 500px !important;
  }
}

@media screen and (max-width: 400px) {
  .col-loader {
    display: flex;
    justify-content: center;
  }
  .loading {
    min-height: 100px;
    height: 500px !important;
  }
}
*/
</style>